export const getProjectName = () => {
  var _hubspot;
  return ((_hubspot = window.hubspot) === null || _hubspot === void 0 || (_hubspot = _hubspot.bender) === null || _hubspot === void 0 ? void 0 : _hubspot.currentProject) || '[unknown]';
};